import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import { GetAutomacaoOrdemServicoResponse } from '@shared/services/responses/servico/get-automacao-ordem-servico.response';
import { ReturnStruct } from '@shared/services/structs/return.struct';
import { AutomacaoOrdemServicoSalvarRequest } from '@shared/services/requests/servico/automacao-ordem-servico-salvar.request';

@Injectable({
  providedIn: 'root',
})
export class AutomacaoOrdemServicoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiServico + 'AutomacaoOrdemServico';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public get(): Observable<GetAutomacaoOrdemServicoResponse> {
    return this.httpClient
      .get<GetAutomacaoOrdemServicoResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvar(request: AutomacaoOrdemServicoSalvarRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}/salvar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
